import { UseMutationOptions } from '@tanstack/react-query'
import { ApiResponse, Job } from 'auth0'
import { AxiosError } from 'axios'
import { useMutationWithAuth } from 'modules/auth/hooks/useMutationWithAuth'
import { Auth0Error } from 'modules/auth/types/auth0'
import { postVerificationEmail } from '../api/postVerificationEmail'

interface Props {
  mutationOptions?: UseMutationOptions<
    ApiResponse<Job>,
    AxiosError<Auth0Error>,
    void
  >
}

export const usePostVerificationEmailMutation = ({
  mutationOptions,
}: Props = {}) => {
  return useMutationWithAuth<ApiResponse<Job>, AxiosError<Auth0Error>, void>({
    mutationFn: postVerificationEmail,
    ...mutationOptions,
  })
}
